import React from 'react';
import { Button, Typography } from 'antd';
import { SafetyCertificateOutlined } from '@ant-design/icons';
import { screeningContextSummary } from '../utils/screening';

const { Text } = Typography;

export default function ContextBanner({ screening, onOpenScreener }) {
  if (!screening) return null;

  return (
    <div className="glp1-context-banner">
      <div className="glp1-context-copy">
        <SafetyCertificateOutlined />
        <Text strong>Using latest screener context</Text>
        <Text type="secondary">{screeningContextSummary(screening)}</Text>
      </div>
      <Button onClick={onOpenScreener}>Run another screening</Button>
    </div>
  );
}
